/** 平台系统 */
export const PLATFORM_CHANNEL = {
  /** 云药房 */
  PHARMACY: 'pharmacy',
  /** 互联网医院 */
  HOSPITAL: 'hospital',
  /** 运营A端 */
  ADMIN: 'admin',
  /** 药师 */
  PHARMACIST: 'pharmacist',
  /** 顾问 */
  CONSULT: 'consult',
  /** COE企业管理平台 */
  COE_ENTERPRISE: 'business'
}

export const DELAY_PERIOD = 5 * 1000 * 60

/** 账号自主注册 */
export const ACCOUNT_ACCESS_TYPE = {
  REGISTER: 'register',
  OA: 'oa'
}

// 药品通管理后台权限按钮和菜单硬编码 2.9.8
// TODO 菜单修改后需要修改此文件
export const ALL_PERMISSION_CODES = [
  /** 审核 */
  'PMN1005334', // 说明书审核
  'PMN1005387', // 说明书审核-查看 按钮
  'PMN1005386', // 说明书审核-审核 按钮
  'PMN1005390', // 审核详情
  'PMN1005601', // 待审核
  /** 说明书 */
  'PMN1005335', // 药品说明书管理
  'PMN1005412', // 药品说明书管理-创建 按钮
  'PMN1005414', // 药品说明书管理-修改 按钮
  'PMN1005415', // 药品说明书管理-查看详情 按钮
  'PMN1005413', // 药品说明书管理-删除 按钮
  'PMN1005417', // 药品说明书管理-生成二维码 按钮
  'PMN1005416', // 药品说明书管理-下载二维码 按钮
  'PMN1005391', // 说明书快照
  'PMN1005340', // 添加药品说明书
  'PMN1005602', // 编辑药品说明书
  'PMN1005389', // 说明书详情
  /** 药品 */
  'PMN1005331', // 药品信息管理
  'PMN1005411', // 药品信息管理-创建 按钮
  'PMN1005409', // 药品信息管理-修改 按钮
  'PMN1005408', // 药品信息管理-查看详情 按钮
  'PMN1005410', // 药品信息管理-删除 按钮
  'PMN1005332', // 药品新增
  'PMN1005600', // 药品编辑
  'PMN1005366', // 药品详情
  /** 数据 */
  'PMN1005647', // 数据概览
  /** 企业设置 */
  'PMN1005326', // 角色管理
  'PMN1005370', // 角色管理-查看 按钮
  'PMN1005369', // 角色管理-编辑 按钮
  'PMN1005367', // 角色管理-新增角色 按钮
  'PMN1005368', // 角色管理-删除 按钮
  'PMN1005362', // 查看角色
  'PMN1005352', // 新增角色
  'PMN1005361', // 编辑角色
  /** ---- */
  'PMN1005325', // 账号管理
  'PMN1005382', // 账号管理-新增账号 按钮
  'PMN1005383', // 账号管理-编辑 按钮
  'PMN1005384', // 账号管理-停用 按钮
  'PMN1005388', // 账号管理-启用 按钮
  'PMN1005363', // 新增账号
  'PMN1005364', // 编辑账号
  // 营销设置
  'PMN1007635', // 营销设置
  'PMN1007637', // 营销设置-添加广告 按钮
  'PMN1007636', // 营销设置-编辑广告 按钮
  'PMN1007639', // 营销设置-广告详情 按钮
  'PMN1007646', // 营销设置-广告详情
  'PMN1007617', // 新增广告
  'PMN1007645' // 编辑广告
]

// 按钮权限
export const PERMISSION_BTN_CODE = [
  /** 审核 */
  'PMN1005387', // 说明书审核-查看
  'PMN1005386', // 说明书审核-审核
  /** 说明书 */
  'PMN1005412', // 药品说明书管理-创建
  'PMN1005413', // 药品说明书管理-删除
  'PMN1005414', // 药品说明书管理-修改
  'PMN1005628', // 药品说明书管理-已投产待修改
  'PMN1005415', // 药品说明书管理-查看详情
  'PMN1005417', // 药品说明书管理-生成二维码
  'PMN1005416', // 药品说明书管理-下载二维码
  /** 药品 */
  'PMN1005411', // 药品信息管理-创建
  'PMN1005410', // 药品信息管理-删除
  'PMN1005409', // 药品信息管理-修改
  'PMN1005408', // 药品信息管理-查看详情
  /** 企业设置 */
  'PMN1005370', // 角色管理-查看
  'PMN1005369', // 角色管理-编辑
  'PMN1005368', // 角色管理-删除
  'PMN1005367', // 角色管理-新增角色
  'PMN1005384', // 账号管理-停用
  'PMN1005388', // 账号管理-启用
  'PMN1005383', // 账号管理-编辑
  'PMN1005382', // 账号管理-新增账号
]

export const PERMISSION_EQUAL_PATH_BTN = {
  /** 企业设置 */
  PMN1005370: 'PMN1005362', // 角色管理-查看 === 查看角色
  PMN1005369: 'PMN1005352', // 角色管理-编辑 === 新增角色
  PMN1005367: 'PMN1005361', // 角色管理-新增角色 === 编辑角色
  PMN1005382: 'PMN1005363', // 账号管理-新增账号 === 新增账号
  PMN1005383: 'PMN1005364', // 账号管理-编辑 === 编辑账号
  /** 营销设置 */
  PMN1007637: 'PMN1007617', // 营销设置-添加广告 按钮 === 新增广告
  PMN1007636: 'PMN1007645', // 营销设置-编辑广告 按钮 === 编辑广告
  PMN1007639: 'PMN1007646' // 营销设置-广告详情 按钮 === 广告详情
}

export const PERMISSION_EQUAL_BTN_PATH = {
  /** 企业设置 */
  PMN1005362: 'PMN1005370', // 查看角色 === 角色管理-查看 按钮
  PMN1005352: 'PMN1005367', // 新增角色 === 角色管理-新增角色 按钮
  PMN1005361: 'PMN1005369', // 编辑角色 === 角色管理-编辑角色 按钮
  PMN1005363: 'PMN1005382', // 新增账号 === 账号管理-新增账号 按钮
  PMN1005364: 'PMN1005383', //  新增账号 === 账号管理-编辑 按钮
  /** 审核 */
  PMN1005390: 'PMN1005387', // 审核详情 === 说明书审核-查看 按钮
  PMN1005601: 'PMN1005386', // 待审核 === 说明书审核-审核 按钮
  /** 说明书 */
  PMN1005340: 'PMN1005412', // 添加药品说明书 === 药品说明书管理-创建 按钮
  PMN1005602: 'PMN1005414', // 编辑药品说明书 === 药品说明书管理-修改 按钮
  PMN1005800: 'PMN1005628', // 编辑药品说明书 === 药品说明书管理-投产后修改 按钮
  PMN1005389: 'PMN1005415', // 说明书详情 === 药品说明书管理-查看详情 按钮
  /** 药品 */
  PMN1005332: 'PMN1005411', // 药品新增 === 药品信息管理-创建 按钮
  PMN1005600: 'PMN1005409', // 审核详情 === 药品信息管理-修改 按钮
  PMN1005366: 'PMN1005408', // 审核详情 === 药品信息管理-查看详情 按钮
  /** 营销设置 */
  PMN1007617: 'PMN1007637', // 新增广告 === 营销设置-添加广告 按钮
  PMN1007645: 'PMN1007636', // 编辑广告 === 营销设置-编辑广告 按钮
  PMN1007646: 'PMN1007639' // 广告详情 === 营销设置-广告详情 按钮
}

export const WHITE_PERMISSION = [
  /** 说明书 */
  'PMN1005391' // 说明书快照
]
